// extracted by mini-css-extract-plugin
module.exports = {"form-input":"SetupTwoFA_form-input__2rL1d","content":"SetupTwoFA_content__w51JZ","qr":"SetupTwoFA_qr__OkjHD","form":"SetupTwoFA_form__2Sbmz"};